import { useTranslation } from 'react-i18next';
import { ImagePlay, Smile } from 'lucide-react';
import { useAuthStore } from '@/features/auth';
import { UserAvatar } from '@/components/ui';

interface StatusUpdateBoxProps {
  onOpenNewPost: () => void;
}

export function StatusUpdateBox({ onOpenNewPost }: StatusUpdateBoxProps) {
  const { t } = useTranslation();
  const user = useAuthStore((s) => s.user);

  const firstName = user?.firstName ?? '';

  return (
    <div
      className="feed-post-flat overflow-hidden mb-2 md:mb-3"
      style={{
        backgroundColor: 'rgba(255,255,255,0.92)',
        borderTop: '1px solid rgba(148, 163, 184, 0.25)',
        borderBottom: '1px solid rgba(148, 163, 184, 0.25)',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
      }}
    >
      {/* Top row: avatar + prompt */}
      <div className="flex items-center gap-3 p-3">
        {/* Profile picture */}
        <UserAvatar
          src={user?.avatarUrl}
          name={firstName}
          size="md"
          className="border border-slate-300/30"
        />

        {/* Prompt text — clickable to open new post modal */}
        <button
          onClick={onOpenNewPost}
          className="flex-1 text-start rounded-full px-4 py-2.5 text-sm transition-colors hover:bg-neutral-200/60 cursor-pointer"
          style={{
            backgroundColor: 'rgba(228, 230, 235, 0.5)',
            color: '#65676B',
          }}
        >
          {t('feed.whatsOnYourMind', { name: firstName })}
        </button>
      </div>

      {/* Divider */}
      <div style={{ borderTop: '1px solid rgba(148, 163, 184, 0.2)' }} />

      {/* Bottom row: action buttons */}
      <div className="flex items-center">
        {/* Photo/Video */}
        <button
          onClick={onOpenNewPost}
          className="flex-1 flex items-center justify-center gap-2 py-2.5 text-sm font-semibold transition-colors hover:bg-neutral-100/60 active:bg-neutral-200/60 cursor-pointer"
          style={{ color: '#65676B' }}
        >
          <ImagePlay className="w-5 h-5" style={{ color: '#45BD62' }} />
          <span>{t('feed.photoVideo')}</span>
        </button>

        {/* Vertical separator */}
        <div className="w-px h-5" style={{ backgroundColor: 'rgba(148, 163, 184, 0.3)' }} />

        {/* Feeling/Activity */}
        <button
          onClick={onOpenNewPost}
          className="flex-1 flex items-center justify-center gap-2 py-2.5 text-sm font-semibold transition-colors hover:bg-neutral-100/60 active:bg-neutral-200/60 cursor-pointer"
          style={{ color: '#65676B' }}
        >
          <Smile className="w-5 h-5" style={{ color: '#F7B928' }} />
          <span>{t('feed.feelingActivity')}</span>
        </button>
      </div>
    </div>
  );
}
